<template>
  <div
    class="tooltip absolute pointer-events-none"
    :class="{
      'opacity-100 ': show,
      'opacity-0 ': !show,
    }"
  >
    <div ref="slot" class="tooltip-inner">
      <slot></slot>
    </div>
    <div ref="arrow" class="tooltip-arrow"></div>
  </div>
</template>

<script>
// https://popper.js.org/docs/v2/constructors/
import { createPopper } from "@popperjs/core";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    html: {
      type: [String, Number],
      default: "",
    },
    left: {
      type: Number,
      default: 0,
    },
    top: {
      type: Number,
      default: 0,
    },
    // width: {
    //   type: Number,
    //   default: 220,
    // },
    height: {
      type: Number,
      default: 25,
    },
    target: {
      type: null,
      default: null,
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {
      width: 100,
    };
  },
  watch: {
    target() {
      this.createPopper();
    },
  },
  mounted() {
    this.createPopper();
  },
  methods: {
    createPopper() {
      this.setWidth();
      if (this.target) {
        this.instance = createPopper(this.target, this.$el, {
          placement: this.placement,
          modifiers: [
            {
              name: "flip",
              enabled: false,
            },
            {
              name: "arrow",
              options: {
                element: this.$refs.arrow,
                padding: 5,
              },
            },
            {
              name: "offset",
              options: {
                offset: [0, 5],
              },
            },
          ],
        });
      }
    },
    setWidth() {
      this.width = this.$refs.slot.clientWidth;
    },
    update() {
      if (this.instance) this.instance.update();
    },
  },
};
</script>
<style>
.tooltip .tooltip-arrow {
  @apply border-opacity-80 border-black;
}

/* top */
.tooltip .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
}
</style>
